import axios from 'axios';
import { AppCustomer } from '../../views/AppOrders/AppOrders';

export function getSchoolByParentCode(customer: AppCustomer, parentCode: string) {
  const { sessionKey: key } = customer;

  const config = {
    headers: { usid: key },
  };

  return axios.get(`${window.apiBase}/customer/schools/${parentCode}`, config).then(response => {
    return response.data;
  });
}
